import { Pipe, PipeTransform } from '@angular/core';
import safe from 'safe-regex';

@Pipe({
    name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

    transform(value: string, term: string): string {
        const expression = `(${term})`;
        if (!safe(expression)) {
            return value;
        }
        const re = new RegExp(expression, 'gi');
        return value.replace(re, '<span class=\'highlight\'>$1</span>');
    }

}
